module.exports = __webpack_public_path__ + "static/media/tortbezowy.5ff6e880.jpg";